import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_CALL_STATUS } from "../../assets/constants/constants";
import api from "../../utils/api";
// import axios from "axios";
api.defaults.withCredentials = true;

const initialState = {
  posts: [], //all posts which any user can see
  savedPosts: [],
  myPost: {}, //when user create a post and again go on create post page
  // homePictures: [],
  post: null,  //when any user click on any post card 
  status: API_CALL_STATUS.IDLE,
  error: null,
};

// async thunk for creating post
export const createPost = createAsyncThunk(
  "post/createPost",
  async (postData, { rejectWithValue }) => {
    try {
      const response = await api.post("/posts", postData);

      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// fetching all posts
export const fetchAllPosts = createAsyncThunk(
  "post/fetchAllPosts",
  async (props, { rejectWithValue }) => {
    const { filterObject, postPage } = props
    try {
      const response = await api.post(`/posts/get-filtered-posts?postCount=6&pageIndex=${postPage}`, filterObject);
      return { data: response.data, postPage };
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// fetching post details
export const fetchPostDetails = createAsyncThunk(
  "post/fetchPostDetails",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/posts/${postId}`);

      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
// fetching post details
export const fetchMyPost = createAsyncThunk(
  "post/fetchMyPost",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await api.get("/posts/get-my-post");
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);


export const toggleSavePost = createAsyncThunk(
  "post/toggleSavePost",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await api.post("/posts/toggle-save-post", { _id: postId });
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//fetch the saved post
export const getSavedPosts = createAsyncThunk(
  "post/getSavedPosts",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await api.get("/posts/get-all-saved-post");

      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);


export const uploadPostPicture = createAsyncThunk(
  "user/uploadPostPicture",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/upload/home-pictures", userData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const deletePostPicture = createAsyncThunk(
  "user/deletePostPicture",
  async (userData, { rejectWithValue }) => {
    try {
      const controller = new AbortController()

      const response = await api.delete("/upload/delete-home-picture", { data: userData, signal: controller.signal });

      controller.abort();
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createPost.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(createPost.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.myPost = action.payload.data
        state.error = null;
      })
      .addCase(createPost.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(fetchAllPosts.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
        //this is commented as we trigger the page lavel error on the basis of api call status as loading
        //but in case of fetching all the forms we have one loader on page itself which works on 
        //scoll event

      })
      .addCase(fetchAllPosts.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        const { data, postPage } = action.payload;
        if (postPage === 1 && data.data.length !== 0) {
          //means onFirst load on after applying filter
          state.posts = action.payload.data.data;
        } else if (postPage !== 1 && data.data.length !== 0) {
          //when we do scroll and we have data to show
          state.posts = [...state.posts, ...data.data]
        } else if (postPage === 1 && data.data.length === 0) {
          //onfirst call only either on first load or after applying filter
          state.posts = []
        }
      })
      .addCase(fetchAllPosts.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(fetchPostDetails.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(fetchPostDetails.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        state.post = action.payload.data;
      })
      .addCase(fetchPostDetails.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(getSavedPosts.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(getSavedPosts.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        state.savedPosts = action.payload.data;
      })
      .addCase(getSavedPosts.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      }).addCase(toggleSavePost.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(toggleSavePost.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
      })
      .addCase(toggleSavePost.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        // state.error = action.payload || "Something went wrong...";
      })
      .addCase(fetchMyPost.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(fetchMyPost.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        state.myPost = action.payload.data;
      })
      .addCase(fetchMyPost.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
        state.myPost = {};
      }).addCase(uploadPostPicture.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(uploadPostPicture.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        // state.homePictures = action.payload.data.residentInfo.homePictures;
        state.myPost.postImages = action.payload.data.residentInfo.homePictures;
      })
      .addCase(uploadPostPicture.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(deletePostPicture.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(deletePostPicture.fulfilled, (state, action) => {
        // state.homePictures = action.payload.data.remainingPictures;
        state.myPost.postImages = action.payload.data.remainingPictures;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(deletePostPicture.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
  },
});

export default postSlice.reducer;
